export default "__VITE_ASSET__BxQfdma5__"